/**
 * Cross-platform browser auto-open utility.
 *
 * Opens a file in the user's default browser.
 * Fire-and-forget — never throws, errors logged to stderr.
 *
 * Uses `execFile` with an argv array (no shell) so a report path containing
 * shell metacharacters can never be interpreted as a command.
 */

import { execFile } from 'node:child_process';

export function openInBrowser(filePath: string): void {
  try {
    const platform = process.platform;
    let file: string;
    let args: string[];

    if (platform === 'darwin') {
      file = 'open';
      args = [filePath];
    } else if (platform === 'win32') {
      // `start` is a cmd builtin, so it must be invoked via cmd.exe. The path
      // is passed as a discrete argv entry (not concatenated into a shell
      // string); the empty "" is the window-title placeholder `start` expects.
      file = 'cmd';
      args = ['/c', 'start', '', filePath];
    } else {
      file = 'xdg-open';
      args = [filePath];
    }

    execFile(file, args, (err) => {
      if (err) {
        process.stderr.write(
          `[testrelic] Failed to open browser: ${err.message}\n`,
        );
      }
    });
  } catch {
    // Never crash the reporter
  }
}
